/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Design || (M.Template.Design = {});

M.Template.Design.HorizontalQuickVote = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n<div class="quickVoteHorizontal">\n  <div class="quickVoteTitle">\n    <button class="buttonFlat buttonSmall\n    ';
 if (rating) { 
__p+='\n      buttonGhostFilled">rated: '+
((__t=( M.html.htmlEscape(rating) ))==null?'':__t)+
'\n    ';
 } else { 
__p+='\n      buttonGhost">rate it\n    ';
 } 
__p+='\n    </button>\n  </div>\n  <div class="hoverPlaceholder"></div>\n  <div class="quickVotePanel">\n    <div class="buttonWrapper">\n      ';
 _.each(buttons, function (button) { 
__p+='\n        <div class="voteButton '+
((__t=( M.html.htmlAttributeEscape(button.class) ))==null?'':__t)+
'"\n          data-value="'+
((__t=( M.html.htmlEscape(button.value) ))==null?'':__t)+
'"\n          data-checked="'+
((__t=( rating === button.value ? 1 : 0 ))==null?'':__t)+
'">\n        <div class="voteButtonIcon ratingScore\n          '+
((__t=( rating === button.value ? 'selected' : '' ))==null?'':__t)+
'">\n          <div class="ratingScoreValue">\n            '+
((__t=( M.html.htmlEscape(button.value) ))==null?'':__t)+
'\n          </div>\n        </div>\n        ';
 if (button.caption) { 
__p+='\n         <div class="caption">\n            '+
((__t=( M.html.htmlEscape(button.caption) ))==null?'':__t)+
'\n         </div>\n        ';
 } 
__p+='\n        </div>\n       ';
 }); 
__p+='\n    </div>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Design.Poll = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n';
 if (!poll.options.hideHeader) { 
__p+='\n  <div class="header">\n    ';
 if (poll.user.id) { 
__p+='\n      ';
 if (poll.userIsDesigner) { 
__p+='\n        ';
 if (poll.model.isNew()) { 
__p+='\n          <h2>Preview your poll below</h2>\n          <button type="button" class="cancel button buttonSecondary\n              buttonMedium floatR">cancel</button>\n          <button type="button" id="startPoll" class="startPoll button\n              buttonPrimary buttonMedium floatR">start poll</button>\n          <div class="createInstructions">\n            You can create up to 4 options for this design to create a poll.\n            When people visit your design submission page, they\'ll see the\n            design options and can specify which option they prefer. You can\n            upload jpeg, png or gif files.\n          </div>\n        ';
 } else { 
__p+='\n          <h2 class="pollResults hideOnMobile">here are the poll results so far:</h2>\n          <button type="button" class="endPoll button buttonSecondary buttonMedium\n              button-inline button-ghost">end poll</button>\n        ';
 } 
__p+='\n      ';
 } else if (poll.user.vote) { 
__p+='\n        <h2 class="voteInfo">\n          Thanks for sharing! here are the poll results so far:\n        </h2>\n      ';
 } else { 
__p+='\n        <h2 class="pollQuestion">which design do you prefer?</h2>\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n      <h2 class="signInToVote">sign in to participate in this poll</h2>\n    ';
 } 
__p+='\n  </div>\n';
 } 
__p+='\n<div class="options clear"></div>\n';
}
return __p;
});

M.Template.Design.PollCreate = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\nWant feedback on different versions of this design?\n<button type="button" class="createPollButton button buttonPrimary buttonMedium">\n  create a poll\n</button>\n';
}
return __p;
});

M.Template.Design.PollEnd = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<form class="pollEndOptionsForm">\n   <ul class="pollEndOptions">\n     ';
 _.each(designVersionOptions, function(option, index) { 
__p+='\n       <li>\n         <label>\n           <input type="radio" name="designVersionOption"\n               value="'+
((__t=( M.html.htmlEscape(option.value) ))==null?'':__t)+
'"\n               '+
((__t=( M.html.htmlAttributeEscape(
                   option.checked ? "checked" : "") ))==null?'':__t)+
' />\n           ';
 if (option.label) { 
__p+='\n             '+
((__t=( M.html.htmlEscape(option.label) ))==null?'':__t)+
'\n           ';
 } else { 
__p+='\n             ';
/* It's a poll option */
__p+='\n             option '+
((__t=( M.html.htmlEscape(option.name) ))==null?'':__t)+
'\n             ('+
((__t=( M.html.htmlEscape(option.votes.percent.toFixed(0)) ))==null?'':__t)+
'%\n             of votes)\n           ';
 } 
__p+='\n         </label>\n     ';
 }); 
__p+='\n     <li class="hideOnMobile">\n       <br />\n       or\n       <a href="/edit-design/'+
((__t=(
           encodeURIComponent(model.get("design").id) ))==null?'':__t)+
'?redirect_url='+
((__t=(
           encodeURIComponent(location.pathname)
           ))==null?'':__t)+
'">\n         upload a new design</a>.\n     </li>\n   </ul>\n   <ul class="floatR inline">\n     <li><a class="button button-ghost secondary h30 cancel">cancel</a></li>\n     <li>\n       <button class="button primary h30 submit" type="submit">\n         submit\n       </button>\n     </li>\n   </ul>\n </form>\n';
}
return __p;
});

M.Template.Design.PollOption = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n\n\n<div>\n   <div class="optionImage">\n     <div class="hoverOverlay hideOnMobile"></div>\n     ';
 if (option.userIsDesigner) { 
__p+='\n     <button type="button" class="addIcon20 uploadImageButton hideOnMobile"></button>\n     ';
 } 
__p+='\n     <img class="disablePointerEvents"\n         ';
 if (option.model.get("image")) { 
__p+='\n           src="'+
((__t=( encodeURI(option.model.get("image")) ))==null?'':__t)+
'"\n         ';
 } 
__p+='\n     />\n   </div>\n   ';
 if (!option.model.id) { 
__p+='\n     <div class="fileuploadProgressbar"></div>\n     <input class="fileupload hide" type="file" name="option" data-url=" '+
((__t=(
       M.html.htmlAttributeEscape(
        option.options.urlPaths['designPollUploadUrlName']) ))==null?'':__t)+
'"\n     >\n   ';
 } 
__p+='\n</div>\n<h6 class="optionName">\n  option '+
((__t=( M.html.htmlEscape(option.name) ))==null?'':__t)+
'\n</h6>\n';
 if ((option.userIsDesigner && option.model.id) ||
       option.user.vote) { 
__p+='\n  <div class="optionResult">\n    <div class="result progressbar"></div>\n    <div class="voteResults">\n      <span class="percent">\n        '+
((__t=( M.html.htmlEscape((option.votes.percent || 0).toFixed(0)) ))==null?'':__t)+
'%\n      </span>\n      ('+
((__t=( M.html.htmlEscape((option.votes.vote_count || 0).toFixed(0)) ))==null?'':__t)+
'\n      of\n      '+
((__t=( M.html.htmlEscape(totalVoteCount || 0) ))==null?'':__t)+
'\n      votes)\n    </div>\n  </div>\n';
 } 
__p+='\n';
}
return __p;
});

M.Template.Design.PollOptionMinimal = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n<div class="large-1 floatL pollOptionsContainer">\n  <div class="pollOptionTag text--tertiary">\n    '+
((__t=( M.html.htmlAttributeEscape(option.name) ))==null?'':__t)+
'</div>\n  <div class="designImageBox">\n    <img class="designImage pollOption"\n      src="'+
((__t=( M.html.htmlAttributeEscape(option.model.get('image')) ))==null?'':__t)+
'" />\n    ';
 if (option.options.hideResults === false && option.isSelectedOption()) { 
__p+='\n      <div class="checkWrapper">\n        <img class="sprite voteIcon16"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n      </div>\n    ';
 } 
__p+='\n    <div class="designOverlayContainer">\n      <a class="designOverlay"></a>\n      <button class="buttonFlat buttonPrimary buttonMedium verticalCenter up10">\n        select this option\n      </button>\n    </div>\n  </div>\n  ';
 if (option.options.hideResults === false) { 
__p+='\n    <div class="percent text--quaternary">\n      '+
((__t=( M.html.htmlEscape((option.votes.percent || 0).toFixed(0)) ))==null?'':__t)+
'%\n    </div>\n    <div class="result progressbar floatL"></div>\n  ';
 } 
__p+='\n</div>';
}
return __p;
});

M.Template.Design.PollVote = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<div class="viewer">\n   <div class="prev floatL">&lt; prev</div>\n   <div class="option floatL">\n     <img class="optionImage" />\n     <span class="caption">\n       option <span class="optionName"></span>\n     </span>\n   </div>\n   <div class="next floatL">next &gt;</div>\n </div>\n <ul class="floatR inline">\n   <li><a class="button primary h30 cancel">cancel</a></li>\n   <li><a class="button primary h30 vote">i prefer this one</a></li>\n </ul>\n';
}
return __p;
});

M.Template.Design.PollVoteSuccess = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<div class="option floatL">\n   <img src="'+
((__t=( thumb ))==null?'':__t)+
'" class="disablePointerEvents" />\n   <br />\n   <h6 class="optionName caption">option\n       '+
((__t=( M.html.htmlEscape(optionName) ))==null?'':__t)+
'</h6>\n </div>\n <div class="comment floatL">\n   <span>make a comment:</span>\n   <div class="fieldWrapper">\n     <textarea class="commentBox"></textarea>\n   </div>\n </div>\n <div class="clear"></div>\n <ul class="floatR inline">\n   <li><a class="button primary h30 cancel">skip comment</a></li>\n   <li><a class="button primary h30 submitComment">submit</a></li>\n </ul>\n';
}
return __p;
});

M.Template.Design.QuickVote = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<div class="quickVoteTitle"><a>\n   ';
 if (rating) { 
__p+='\n     rated: '+
((__t=( M.html.htmlEscape(rating) ))==null?'':__t)+
'\n   ';
 } else { 
__p+='\n     rate design\n   ';
 } 
__p+='\n </a></div>\n <div class="quickVotePanel">\n   <div class="customerDesignInterest">\n     <label>\n       <input type="checkbox"\n         '+
((__t=( customerDesignInterest ? "checked" : "" ))==null?'':__t)+
' />\n       I\'d buy it!\n     </label>\n   </div>\n   <ul class="standard">\n     ';
 _.each(buttons, function (button) { 
__p+='\n       <li class="voteButton '+
((__t=( M.html.htmlAttributeEscape(button.class) ))==null?'':__t)+
'"\n           data-value="'+
((__t=( M.html.htmlEscape(button.value) ))==null?'':__t)+
'"\n           data-checked="'+
((__t=( rating === button.value ? 1 : 0 ))==null?'':__t)+
'">\n        <div class="voteButtonIcon">\n          <img class="numberSmall-'+
((__t=( M.html.htmlEscape(button.value) ))==null?'':__t)+
'"\n            src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'" />\n        </div>\n         ';
 if (button.caption) { 
__p+='\n           <span class="caption">\n             '+
((__t=( M.html.htmlEscape(button.caption) ))==null?'':__t)+
'\n           </span>\n         ';
 } 
__p+='\n       </li>\n    ';
 }); 
__p+='\n   </ul>\n <div>\n';
}
return __p;
});

M.Template.Design.RequestForFeedbackBox = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<div class="box bm">\n  <div class="floatL">\n    <h2><b>Congratulations!</b></h2>\n    <h2>Your design is now ready to get feedback</h2>\n  </div>\n  <div class="floatR">\n    <ul>\n      <li>\n        <a class="button primary h30 requestFeedback">ask for feedback</a>\n      </li>\n      <li>\n        <a class="button primary h30 cancel">no thanks</a>\n      </li>\n    </ul>\n  </div>\n</div>\n';
}
return __p;
});

M.Template.Design.RequestForFeedbackConfirmation = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<p>Want even more feedback? Help other artists! Contributing back\n to the community is the best way to get discovered. Favorite and\n  comment on the best designs in the '+
((__t=( contestName ))==null?'':__t)+
'</p>\n <ul class="floatR inline">\n   <li><a href="/challenge/'+
((__t=( contestId ))==null?'':__t)+
'"\n     class="button primary h30">view designs</a></li>\n   <li><a class="button primary h30 cancel">stay here</a></li>\n </ul>\n';
}
return __p;
});

M.Template.Design.RequestForFeedbackDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<p class="warning hidden">Please enter your feedback request.</p>\n <p class="bm">In a few words, ask the community for the type of feedback you\n   would like to receive. e.g. "Is green the right color here?"\n   or "Is this design too busy?"</p>\n<div class="fieldWrapper">\n   <textarea style="width:490px;height:125px;resize:none;"></textarea>\n </div>\n <ul class="floatR inline">\n   <li><a class="button primary h30 askButton">ask</a></li>\n   <li><a class="button primary h30 cancel">nevermind</a></li>\n </ul>\n';
}
return __p;
});

M.Template.Design.RequestForFeedbackResetDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2013 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n\n<p>Are you sure you\'d like to end your feedback request?</p>\n<ul class="floatR inline">\n   <li><a class="button primary h30 reset">cancel request</a></li>\n   <li><a class="button primary h30 cancel">nevermind</a></li>\n </ul>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
